/**
 * Business Profile Types
 *
 * One-to-one relationship with User.
 * Each user account represents exactly one business.
 */

export type FormatType = 'HOSPITALITY' | 'NON_HOSPITALITY';

export interface BusinessProfile {
  id: number;
  employer_ni_number: string;
  company_name: string;
  trading_name: string | null;
  format_type: FormatType;
  industry_sector: string | null;
  contact_email: string | null;
  contact_phone: string | null;
  address_line1: string | null;
  address_line2: string | null;
  city: string | null;
  island: string | null;
  is_complete: boolean;
  created_at: string | null;
}

export interface BusinessProfileSetupRequest {
  employer_ni_number: string;
  company_name: string;
  format_type: FormatType;
  trading_name?: string;
  industry_sector?: string;
  contact_email?: string;
  contact_phone?: string;
  island?: string;
}

export interface BusinessProfileUpdateRequest {
  company_name?: string;
  trading_name?: string;
  format_type?: FormatType;
  industry_sector?: string;
  contact_email?: string;
  contact_phone?: string;
  address_line1?: string;
  address_line2?: string;
  city?: string;
  island?: string;
}

export interface BusinessProfileResponse {
  success: boolean;
  data: BusinessProfile | null;
  is_setup: boolean;
}

export interface BusinessStatusResponse {
  success: boolean;
  is_complete: boolean;
}

// Bahamas Islands for dropdown
export const BAHAMAS_ISLANDS = [
  'New Providence',
  'Grand Bahama',
  'Abaco',
  'Eleuthera',
  'Exuma',
  'Andros',
  'Long Island',
  'Cat Island',
  'San Salvador',
  'Inagua',
  'Bimini',
  'Berry Islands',
  'Acklins',
  'Crooked Island',
  'Mayaguana',
  'Ragged Island',
] as const;

export type BahamasIsland = (typeof BAHAMAS_ISLANDS)[number];
